/* eslint-disable new-cap */
import { Controller } from "@hotwired/stimulus"
import { debounce } from "lodash"
import flatpickr from "flatpickr"
import rangePlugin from "flatpickr/dist/plugins/rangePlugin"
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect"
import { datepickerLocales } from "../locales/datepicker"

export default class extends Controller {
  static values = {
    format: { type: String, default: "Y-m-d" },
    locale: { type: String, default: "pl" },
    range: { type: Boolean, default: false },
    endInput: String,
    // "date" (pełna data) albo "month" (tylko miesiąc+rok, bez dnia — np. mfr_date na formatce
    kind: { type: String, default: "date" }
  }

  connect() {
    console.log("picker")

    const options = {
      locale: {
        ...this.locale,
        firstDayOfWeek: 1
      },
      dateFormat: this.formatValue,
      allowInput: true,
      disableMobile: this.kindValue === "month",
    }

    if (this.rangeValue) {
      options.plugins = [new rangePlugin({ input: this.endInputValue })]
    } else if (this.kindValue === "month") {
      options.altInput = true
      options.plugins = [new monthSelectPlugin({ shorthand: false, dateFormat: this.formatValue, altFormat: "F Y" })]
    }

    this.picker = flatpickr(this.element, options)

    if (this.kindValue !== "month") {
      const handleInput = debounce(() => {
        const val = this.element.value.trim()
        try {
          const parsed = this.picker.parseDate(val, this.formatValue)

          if (parsed instanceof Date && !isNaN(parsed)) {
            const formatted = this.picker.formatDate(parsed, this.formatValue)
            if (val === formatted) {
              this.picker.setDate(parsed, true)
            }
          }
        } catch (err) {
        }
      }, 500)

      this.element.addEventListener("keyup", handleInput)
    }
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }

  get locale() {
    if (this.hasLocaleValue) {
      return datepickerLocales[this.localeValue] || {}
    }

    return nil
  }
}
